import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CompanyService } from '@company/feature';
import { CurrentProfile } from '@user/const';
import { CurrentProfileService } from '@user/feature';
import { Observable } from 'rxjs';

@Component({
  selector: 'sd-checkout-switch-profile',
  templateUrl: './checkout-switch-profile.component.html',
  styleUrls: ['./checkout-switch-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdCheckoutSwitchProfileComponent implements OnInit {
  currentProfile$: Observable<CurrentProfile>;

  constructor(
    private currentProfileService: CurrentProfileService,
    private companyService: CompanyService,
  ) {}

  ngOnInit(): void {
    this.currentProfile$ = this.currentProfileService.get();
  }

  selectCompany(companyUid: string): void {
    this.companyService.selectCompany(companyUid);
  }

  resetCompany(): void {
    this.companyService.resetSelectedCompany();
  }

  preventDefault(e: Event): void {
    e.preventDefault();
    e.stopPropagation();
  }
}
